import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs/Observable';

// Minimal contract HttpService needs from the refresh coordinator. Declared here
// (not imported from auth-refresh.service) on purpose — see the token note below.
export interface RefreshCoordinator {
  handle401<T>(retry: () => Observable<T>): Observable<T>;
}

// Lookup token for AuthRefreshService, used by HttpService.
//
// HttpService must NOT statically import AuthRefreshService: that closes the module
// import cycle HttpService -> AuthRefreshService -> AuthService -> HttpService, which
// under JIT leaves HttpService `undefined` while Angular reads AuthService's constructor
// metadata ("Can't resolve all parameters for AuthService: (?, ...)"). Looking the
// coordinator up by this token keeps HttpService free of that value-import while staying
// type-safe via the RefreshCoordinator interface above.
export const AUTH_REFRESH_SERVICE = new InjectionToken<RefreshCoordinator>('AUTH_REFRESH_SERVICE');



// WEBPACK FOOTER //
// ./src/app/auth/auth-refresh-service.token.ts